import { inviteAdmin, updateAdmin } from '@services/AdminService'
import { deleteAdmin } from '@store/AdminReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

type RoleOption = {
  id: number
  name: string
  entity: string | null
}

export type RoleFormItem = {
  role: RoleOption | null
  entity: string | null
  extraIds: number[] | null
}

export const AdminForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.admin)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) => {
          await inviteAdmin({
            email: values.email,
            roles: values.roles.map((item: any) => ({
              ...item,
              id: item.role,
            })),
          })

          return true
        },
        update: async (values) => {
          /**
           * This is a service method
           * It doesn't go through the store
           * However once succeded we rely on admin list refetch to update the data in store
           */
          await updateAdmin({
            ...values,
            roles: values.roles.map((item: any) => ({
              ...item,
              id: item.role,
            })),
          }).then(() => {
            return true
          })
          return true
        },
        delete: async (values) =>
          dispatch(deleteAdmin(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

AdminForm.displayName = 'AdminForm'

export default AdminForm
